import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { quickExchangeInitStepDeclaration } from "./Steps/QuickExchangeInitStep";
import { quickExchangeNextPrevStepDeclaration } from "./Steps/QuickExchangeNextPrevStep";
import { QuickExchangeTransition } from "./Transition/QuickExchangeTransition";

export const quickExchangeStartupFlow = new FlowDefinition("QuickExchangeFlow");

quickExchangeStartupFlow.addStep(quickExchangeInitStepDeclaration);
quickExchangeStartupFlow.addStep(quickExchangeNextPrevStepDeclaration);
quickExchangeStartupFlow.addStep(checkoutStepDefinition);

quickExchangeStartupFlow.addLink("QuickExchangeInitStep_Step", "QuickExchangeNextPrev_Step")
quickExchangeStartupFlow.addLink("QuickExchangeNextPrev_Step", "CheckoutFlow")

quickExchangeStartupFlow.addTransition(QuickExchangeTransition, "QuickExchangeInitStep_Step")
quickExchangeStartupFlow.addTransition(QuickExchangeTransition, "QuickExchangeNextPrev_Step")

quickExchangeStartupFlow.setStartStep("QuickExchangeInitStep_Step");

export const quickExchangeStepFlowDefinition = new StepDefinition({
    stepName: "QuickExchangeFlow",
    stepFlow: quickExchangeStartupFlow,
    contextIsolation: false
})
